import { Spacer } from "@nextui-org/react"
import { Box } from "../box"

export const Content = ({id, children, spacerSize=0, contentCss={}}) => (
  <Box id={id} css={Object.assign({px: "$12", mt: "$8", "@xsMax": {px: "$10"}}, contentCss)}>
    <Spacer y={spacerSize} />
    {children}
  </Box>
);
